import { useCallback, useRef } from 'react';
import CustomSelect from '@components/FormFields/CustomSelect';
import * as ApiModels from '@typings/api-models';

const FREQUENCY_OPTIONS: { key: string; title: string; value: ApiModels.PaymentPlan['frequency'] }[] = [
  {
    key: 'monthly',
    title: 'Every month',
    value: 'monthly',
  },
  {
    key: 'biweekly',
    title: 'Biweekly',
    value: 'biweekly',
  },
  {
    key: 'weekly',
    title: 'Every week',
    value: 'weekly',
  },
];

export const DEFAULT_FREQUENCY: ApiModels.PaymentPlan['frequency'] = FREQUENCY_OPTIONS[0].value;

type Props = {
  value: string;
  onChange: (newValue: ApiModels.PaymentPlan['frequency']) => void;
};

const FrequencyPicker: React.FC<Props> = ({ value, onChange }) => {
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  const handleChange = useCallback((newFrequency: string): void => {
    // as is OK because value in FREQUENCY_OPTIONS is ApiModels.PaymentPlan['frequency']
    onChangeRef.current(newFrequency as ApiModels.PaymentPlan['frequency']);
  }, []);

  return (
    <CustomSelect
      label='Frequency'
      value={value}
      id='frequency'
      onChange={handleChange}
      options={FREQUENCY_OPTIONS}
    />
  );
};

export default FrequencyPicker;
